import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Card, CardContent, Typography, Box, Link} from '@mui/material'
import { useDrag } from 'react-dnd'
import { useTranslation } from 'react-i18next'
import { SelectStatus } from '../../components'
import { deliveryOrderStatuses } from '../../lib/statuses'
import { formatDeliveryTimeRange, getDate } from '../../lib/utils'
import { STATUSES } from '../../lib/constants'

// Drag and Drop item types
const ItemTypes = {
  ORDER: 'order',
}

const OrderCard = ({ deliveryOrder, fromDriverId, isDragDisabled }) => {
  const { t } = useTranslation('planning_page')
  const [showMore, setShowMore] = useState(false)
  const [{ isDragging }, ref] = useDrag({
    type: ItemTypes.ORDER,
    item: { id: deliveryOrder.id, name: deliveryOrder.name, fromDriverId: fromDriverId },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  })

  const toggleShowMore = () => {
    setShowMore(!showMore)
  }

  return (
    <>
      <Card
        ref={ref}
        style={{
          width: '350px',
          flexShrink: 0,
          opacity: isDragging ? 0.5 : 1,
          backgroundColor: deliveryOrder.status === STATUSES.VALID 
          ? "#d4edda" // Vert très clair si `status` validé est défini
          : isDragDisabled 
          ? "#ccc" // Gris clair si `isDragDisabled` est vrai (status valid ou date passé)
          : "" // Aucun style spécifique sinon
        }}
      >
        <CardContent>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h6" style={{ fontWeight: 'bold' }}>
              {deliveryOrder.command.clientName}
            </Typography>
          </Box>
          <Box
            display="flex"
            flexDirection="row"
            alignItems="center"
            marginTop={1}
            marginBottom={1}
          >
            <Typography
              style={{
                backgroundColor: '#d3e0ea', // Light blue-gray background color
                padding: '4px 8px', // Optional: Add padding for better visual spacing
                borderRadius: '4px', // Optional: Add rounded corners
              }}
            >
            {getDate(deliveryOrder.deliveryDate)} {formatDeliveryTimeRange(deliveryOrder.deliveryTimeStart, deliveryOrder.deliveryTimeEnd)}
            </Typography>
            <Box style={{ marginLeft: '5%' }}>
              <SelectStatus
                status={deliveryOrder.status}
                statuses={deliveryOrderStatuses()}
                isDisabled={true}
              />
            </Box>
          </Box>
          <Typography>
            {deliveryOrder.deliverySiteBdn && deliveryOrder.deliverySiteBdn.address
              ? deliveryOrder.deliverySiteBdn.address
              : deliveryOrder.deliverySite && deliveryOrder.deliverySite.address && deliveryOrder.deliverySite.city
              ? `${deliveryOrder.deliverySite.address} ${deliveryOrder.deliverySite.city}`
              : deliveryOrder.deliverySiteAddress && deliveryOrder.deliverySiteCity
              ? `${deliveryOrder.deliverySiteAddress} ${deliveryOrder.deliverySiteCity}`
              : t('NA')}
          </Typography>
          <Link onClick={toggleShowMore}>{showMore ? t('seeLess') : t('seeMore')}</Link>
          {showMore && (
            <Box mt={2}>
              <Typography><strong>{t('orderNumber')} :</strong> {deliveryOrder.command.commandNumber}</Typography>
              {deliveryOrder.orderDeliveryMaterials?.nodes?.length > 0 && (
                <Box mt={1}>
                  <Typography fontWeight="bold">{t('products')} :</Typography>
                  {deliveryOrder.orderDeliveryMaterials.nodes.map((material, index) => (
                    <Typography key={index}>
                      {material.material.description}: {material.quantity} {material.material.measureUnitByBaseMeasureUnitCode.abbr}
                    </Typography>
                  ))}
                </Box>
              )}
              <Typography>{deliveryOrder.command.contactPhone}</Typography>
              <Typography>{deliveryOrder.command.comment}</Typography>
            </Box>
          )}
        </CardContent>
      </Card>
    </>
  )
}

OrderCard.propTypes = {
  deliveryOrder: PropTypes.any.isRequired,
  isDragDisabled:PropTypes.bool,
  fromDriverId: PropTypes.string, // This prop is passed from the DriverCard component
}
export default OrderCard